import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@material-ui/core";
import useStyles from "./styles";

const IconButton = ({
  icon,
  children,
  className,
  loading,
  disabled,
  ...rest
}) => {
  const { content, circular } = useStyles();
  return (
    <Button
      className={`${content} ${className}`}
      {...rest}
      disabled={disabled || loading}
    >
      {loading ? (
        <CircularProgress size={14} className={circular} />
      ) : (
        <span>{icon}</span>
      )}
      <label className="capitalize">{children || " - "}</label>
    </Button>
  );
};

IconButton.defaultProps = {
  icon: undefined,
  children: null,
  className: "",
  loading: false,
  disabled: false,
};

IconButton.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default IconButton;
